// src/data/newsData.js

import { DeepCosmicMeditation } from "./meditationData";

/**
 * Configuración para las novedades y elementos recién agregados.
 * - title: El título de la novedad.
 * - link: La URL a la que enlazará.
 * - date: La fecha de publicación para ordenar. Formato YYYY-MM-DD.
 * - description: Un breve texto descriptivo.
 */
export const newsData = [
  {
    title: 'The Money Workshop Now Available',
    link: '/bashar/tools#the-money-workshop',
    date: '2026-06-15',
    description: 'Discover the transformative principles of financial empowerment with The Money Workshop, now available in your coaching dashboard.',
  },
  {
    title: 'Seven Phase Meditation Now Available',
    link: '/7-phase-meditation',
    date: '2026-01-12',
    description: 'Experience the renowned Seven Phase Meditation for spiritual growth and inner peace.',
  },
  {
    title: 'Seven Phase Meditation Now Available',
    link: '/7-phase-meditation',
    date: '2026-01-12',
    description: 'Experience the renowned Seven Phase Meditation for spiritual growth and inner peace.',
  },
  {
    title: 'Portal Oracle Now Available',
    link: '/en',
    date: '2026-01-04',
    description: 'Discover insights and guidance from the newly launched Portal Oracle deck, designed to help you navigate your spiritual journey.',
  },
  {
    title: 'Comment Sections Added to Decks',
    link: '/sacred-circuitry-oracle',
    date: '2025-10-19',
    description: 'Now you can engage with other users by leaving comments and sharing your experiences on each deck page.',
  },
  {
    title: 'Joe Dispenza Explains the Power of Gamma Brainwaves',
    link: '/bashar/tools#gamma-measurements',
    date: '2025-10-16',
    description: 'Discover how gamma brainwaves can enhance your meditation practice and overall well-being in this insightful video by Dr. Joe Dispenza.',
  },
  {
    title: 'Welcome to the New Dashboard',
    link: '/user/dashboard',
    date: '2025-10-13',
    description: 'Your user dashboard has been redesigned for a better and more intuitive experience.',
  },
  {
    title: DeepCosmicMeditation.title,
    link: '/user/healing-meditations#deep-cosmic-exploration-meditation',
    date: '2025-10-12',
    description: DeepCosmicMeditation.description,
  },
  {
    title: '15 Minutes and Counting Tool Added',
    link: '/bashar/tools#15-minutes-and-counting',
    date: '2025-10-11',
    description: 'A new practical tool from Bashar to help you reprogram limiting beliefs and align with your highest excitement.',
  },
  {
    title: 'Bashar Tools Updated',
    link: '/bashar/tools',
    date: '2025-09-28',
    description: 'We have added new practical tools and resources from Bashar to assist you in your daily life.',
  },
];